import { Fragment, useEffect } from "react";

import { Navigate, Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { useEBSSS } from "src/base/context/EBSSSContext/useEBSSS";
import { getQueryParams } from "src/_utils/urls";
import { scrollUpPage } from "src/_utils/elements";
import { useEBSSSLayout } from "src/base/context/EBSSSLayoutContext/useEBSSSLayout";

const CMSContainer = ({ hideLayout, children, classNames, ...rest }) => {
  const [state, setSearchParams] = useSearchParams();
  const { htmlPage, setLoaded, fetchHtmlPage, setProduct } = useEBSSS();
  const { setCMSSnapshot } = useEBSSSLayout();
  const location = useLocation();
  const navigate = useNavigate();

  const resetWindowProductState = () => {
    window["PRODUCT_PAYMENT_TYPE"] = [];
    window["PRODUCT_EXTRAS"] = [];
    window["PRODUCT_RENTAL_DATE"] = null;
    window["PRODUCT_SLOT"] = null;
    window["PRODUCT_SHIFT"] = null;
    window["PRODUCT_ENTITY"] = null;
    window["PRODUCT_AGE_RANGES"] = null;
    window["PRODUCT_RENTAL_START_END_DATE"] = null;
    window["HTTP_REQUESTS_IN_PROGRESS"] = null;
  };

  useEffect(() => {
    if (getQueryParams(window.location.href)?.action === "logout") {
      setSearchParams({});
      window.location.reload();
      return;
    }
    if (typeof document !== "undefined") {
      console.log(window.location.origin + location.pathname + location.search);
      setProduct(null);
      let paramsFromUrl = getQueryParams(window.location.origin + location.pathname + location.search);
      let pathnameWithoutVersion = location.pathname.split("/v2/")[1];
      resetWindowProductState();
      fetchHtmlPage({ page: pathnameWithoutVersion, queryParams: paramsFromUrl })
        .then((r) => {
          scrollUpPage();
          if (!r) {
            console.log("NOT FOUND PAGE IN CMS!");
            return navigate(`${process.env.PUBLIC_URL}/404`);
          }
          return null;
        })
        .finally(() => {
          console.log("Loaded raw HTML from API");
          localStorage.setItem(window.location.host.toUpperCase() + "_ACTUAL_URL", location.pathname + location.search);
          window.dispatchEvent(
            new StorageEvent("storage", {
              key: window.location.host.toUpperCase() + "_ACTUAL_URL",
              newValue: location.pathname + location.search,
              storageArea: localStorage,
            })
          );
        });
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    setCMSSnapshot(htmlPage);
  }, [htmlPage]);

  useEffect(() => {
    // setLoaded(false);
  }, [location.pathname]);

  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
};
export default CMSContainer;
